/**
 * 과거 수업 수강 명단 정규화 유틸 (서버/클라이언트 공용)
 *
 * 매칭 키는 이름과 전화번호이므로, 엑셀 입력 / auth.users.user_metadata.phone /
 * 회원가입 입력값이 모두 동일한 규칙으로 정규화되어야 일치한다.
 * 이 모듈은 의존성이 없어야 하며(서버/프론트 양쪽에서 import), 규칙을 한 곳에서만 정의한다.
 */

/** 이름 정규화: 앞뒤 공백 제거 + 내부 연속 공백을 단일 공백으로 */
export function normalizeName(raw: unknown): string {
  return String(raw ?? '')
    .trim()
    .replace(/\s+/g, ' ');
}

/**
 * 전화번호 정규화: 숫자만 추출 후 한국 휴대폰 11자리(010...) 기준으로 복원.
 * - 하이픈/공백/괄호 등 제거
 * - 엑셀이 숫자로 읽어 선행 0이 손실된 경우(10자리, '10'으로 시작) 앞에 '0' 부착 → '010...'
 * - 11자리 '010' 시작이면 그대로
 * 그 외 형식은 그대로 digits를 반환하되, isValidKoreanMobile로 별도 판별한다.
 */
export function normalizePhone(raw: unknown): string {
  let digits = String(raw ?? '').replace(/\D/g, '');

  // 국가번호 82 처리: 8210... → 010...
  if (digits.length === 12 && digits.startsWith('82')) {
    digits = '0' + digits.slice(2);
  } else if (digits.length === 11 && digits.startsWith('82')) {
    digits = '0' + digits.slice(2);
  }

  // 선행 0 손실 복원: 10자리이고 '10'으로 시작 → '010...'
  if (digits.length === 10 && digits.startsWith('10')) {
    digits = '0' + digits;
  }

  return digits;
}

/** 정규화된 전화번호가 유효한 한국 휴대폰 번호(010 + 8자리)인지 */
export function isValidKoreanMobile(normalizedPhone: string): boolean {
  return /^010\d{8}$/.test(normalizedPhone);
}

/** 매칭 키 생성: `${normalizedName}|${normalizedPhone}` */
export function rosterMatchKey(name: unknown, phone: unknown): string {
  return `${normalizeName(name)}|${normalizePhone(phone)}`;
}
